// ReadingComprehension.js
import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  container: {
    marginBottom: 12,
  },
  passage: {
    marginBottom: 8,
    fontSize: 12,
    lineHeight: 1.4,
  },
  question: {
    marginLeft: 12,
    marginBottom: 4,
    fontSize: 12,
  },
});

export default function ReadingComprehension({ data, typeOfContent }) {
  return (
    <View style={styles.container}>
      <Text style={styles.passage}>{data.passage}</Text>

      {typeOfContent === "worksheet_marksheet" ? (
        <>
          {data.answers.map((a, index) => (
            <Text key={index} style={styles.question}>
              A{index + 1}: {a}
            </Text>
          ))}
        </>
      ) : (
        <>
          {data.questions.map((q, index) => (
            <Text key={index} style={styles.question}>
              Q{index + 1}: {q}
            </Text>
          ))}</>
      )}
    </View>
  );
}
